<template>
  <div id="app" class="pure-g">

    <PulseLoader class="loading-indicator" v-if="user===null"></PulseLoader>
    <LoginPage v-if="user===false"></LoginPage>
    <router-view  v-if="user"></router-view>

  </div>
</template>

<style lang="scss" src="./style/index.scss"></style>

<script>
import { mapGetters } from "vuex";
import PulseLoader from "vue-spinner/src/PulseLoader";
import LoginPage from "@/components/LoginPage";

export default {
  name: "app",
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      "user",
      "appTitle",
      "loading",
    ]),
  },
  components: {
    LoginPage,
    PulseLoader,
  },
};
</script>


<style>
#app {
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// App.vue?bc9119bc